import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import axios from 'axios'

// 定义响应类型
const baseURL = 'http://localhost:10233'
const service = axios.create({
  // baseURL: baseURL,
  timeout: 15000, // request timeout
  withCredentials: true,
})

// 请求拦截
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // 这里可以添加请求头或其他预处理逻辑
    config.headers = { 'content-type': 'application/json' }

    return config
  },
  (error: any) => Promise.reject(error)
)

// 响应拦截
service.interceptors.response.use(
  (response: AxiosResponse) => {
    const res = response.data

    if (res.code !== 1 || res.code !== 200) {
      return Promise.resolve(response.data)
    } else {
      return Promise.resolve(response.data)
    }
  },
  (error: any) => {
    if (error.response) {
      switch (error.response.status) {
        case 500:
          console.log('服务器错误，请稍后重试')
          break
        default:
          return Promise.reject(error)
      }
    }

    return Promise.reject(error.message)
  }
)

export default service
